jQuery(function ($) {
  var innerHeight = 0;
  var stackedContainerHeight = 0;

  /*
   * on window resize, calculate inner height of of children in
   * each container
   */
  $(window).resize(function () {
    $('.how_to_container').each(function () {
      /*
       * If window is wider than 1050px only calculate inner div height
       * else calculate innder div AND image height
       */
      if ($(window).width() < 1050) {
        $(this)
          .find('.step_container')
          .children()
          .each(function () {
            innerHeight = innerHeight + $(this).outerHeight();
          });
      } else {
        innerHeight = 389;
      }

      $(this).css({ height: innerHeight.toString() + 'px' });

      stackedContainerHeight = stackedContainerHeight + innerHeight;

      innerHeight = 0;
    });

    stackedContainerHeight = 0;
  });
});
